var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('a',{staticClass:"pdf-link",attrs:{"target":"_blank","href":_vm.fileUrl}},[(_vm.iconSrc)?_c('img',{staticClass:"icon-pdf",attrs:{"alt":"icon-pdf","src":_vm.iconSrc}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }